import styled from 'styled-components';

import { VehiclePreview } from '../VehiclePreview';

const StyledImgContainer = styled.div`
	display: flex;
	justify-content: center;
	align-items: center;
	position: absolute;
	top: 0;
	left: 0;
	width: 100%;
	height: 100%;
`;

const StyledImg = styled(VehiclePreview)`
	max-width: 80%;
	max-height: 80%;
`;

export { StyledImgContainer, StyledImg };
